
import { defineComponent } from "vue";

import { HomeIcon, SettingsIcon, ViewListIcon } from "@tager/admin-ui";
import { MenuItemType, PageLayout } from "@tager/admin-layout";

import { LINKS } from "@/constants/links";

export default defineComponent({
  name: "BaseApp",
  components: { PageLayout },
  setup() {
    const sidebarMenuList: Array<MenuItemType> = [
      { id: "home", icon: HomeIcon, ...LINKS.HOME },
      {
        id: "products",
        icon: ViewListIcon,
        text: "Товары",
        children: [LINKS.PRODUCT_LIST, LINKS.BASIS_PRODUCT_LIST],
      },
      {
        id: "categories",
        icon: ViewListIcon,
        text: "Категории",
        children: [LINKS.CATEGORY_LIST, LINKS.CATEGORY_TREE],
      },
      {
        id: "catalog",
        icon: ViewListIcon,
        text: "Каталог",
        children: [
          LINKS.PRODUCT_TYPE_LIST,
          LINKS.PRODUCT_GROUP_LIST,
          LINKS.SPECIAL_LIST,
          LINKS.COLLECTION_LIST,
          LINKS.BRANDS_LIST,
        ],
      },
      {
        id: "exportAndImport",
        icon: ViewListIcon,
        text: "Экспорт / Импорт",
        children: [LINKS.EXPORT_LIST, LINKS.IMPORT_LIST],
      },
      { id: "pages", icon: ViewListIcon, ...LINKS.PAGE_LIST },
      {
        id: "menu",
        icon: ViewListIcon,
        text: "Меню",
        children: [
          LINKS.MENU_TOP,
          LINKS.MENU_MAIN,
          LINKS.MENU_CATALOG,
          LINKS.MENU_BOTTOM,
        ],
      },
      {
        id: "blog",
        icon: ViewListIcon,
        text: "Блог",
        children: [LINKS.BLOG_POST_LIST, LINKS.BLOG_CATEGORY_LIST],
      },
      {
        id: "term",
        icon: ViewListIcon,
        ...LINKS.TERM,
      },
      {
        id: "seo",
        icon: ViewListIcon,
        text: "SEO",
        children: [LINKS.SEO_LIST_CATEGORY, LINKS.SEO_TEMPLATES],
      },
      {
        id: "email",
        text: "E-Mail",
        icon: ViewListIcon,
        children: [LINKS.EMAIL_TEMPLATE_LIST, LINKS.EMAIL_LOG_LIST],
      },
      {
        id: "settings",
        icon: SettingsIcon,
        text: "Настройки",
        url: LINKS.SETTINGS_COMMON.url,
      },
      {
        id: "files",
        icon: ViewListIcon,
        text: "Файлы",
        url: LINKS.FILES_LIST.url,
      },
      {
        id: "admins",
        text: "Администраторы",
        icon: SettingsIcon,
        children: [LINKS.ADMIN_ADMINS, LINKS.ADMIN_ROLES],
      },
    ];

    return {
      sidebarMenuList,
    };
  },
});
